import React, { FunctionComponent } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import SvgHomeLinkButton from '../generated/svg/home-link-button'
import SvgInstagramIcon from '../generated/svg/instagram-icon'
import SvgLogo from '../generated/svg/logo'
import SvgLogoWithRecruit from '../generated/svg/logo-with-recruit'
import SvgRecHeaderContact from '../generated/svg/rec-header-contact'
import SvgRecHeaderMousikomi from '../generated/svg/rec-header-mousikomi'
import SvgRecHeaderSetumei from '../generated/svg/rec-header-setumei'
import SvgRecMobileHeaderContact from '../generated/svg/rec-mobile-header-contact'
import SvgRecMobileHeaderMousikomi from '../generated/svg/rec-mobile-header-mousikomi'
import SvgRecMobileHeaderSetumei from '../generated/svg/rec-mobile-header-setumei'
import SvgTiktokIcon from '../generated/svg/tiktok-icon'
import SvgYoutubeIcon from '../generated/svg/youtube-icon'
import { useBreakpoint } from '../hooks/use-breakpoint'
import { MobileHeaderMenu } from './mobile-header-menu'

const Outer = styled.div`
  position: relative;
  height: 5.5rem;
  gap: 1rem;
  @media (max-width: 50rem){
    height: 7rem;
  }
`
const Inner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
`

const Inner2 = styled.div`
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  box-sizing: border-box;
  @media (max-width: 40rem){
    padding: 0.5rem 1rem;
    min-height: 3.5rem;
  }

`

const LogoContainer = styled(Link)`
  display: block;
  z-index: 1;
  svg {
    display: block;
    height: 4rem;
    @media (max-width: 60rem){
      height: 2.5rem;
    }
    @media (max-width: 40rem){
      height: 2rem;
    }
  }
`

const MenuContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 2rem;
  gap: 0 1.5rem;
  justify-content: flex-end;
`

const MenuItem = styled(Link)`
  padding: 0.25rem 0;
  display: block;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.1em;
  line-height: 1.5;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    text-decoration: underline;
  }
`

const ButtonContainer = styled.div`

`

const HomeButtonContainer = styled(Link)`
  display: block;
  svg {
    height: 2rem;
    width: auto;
    @media (max-width: 50rem){
      height: 1.75rem;
    }
    @media (max-width: 30rem){
      height: 1.1rem;
    }
  }
`

const RecruitItem = styled.div`
  display: flex;
  gap: 0.5rem;
`

const RecruitIconContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-self: center;
`

const RecruitIconItem = styled.a`
  display: block;
  svg {
    display: block;
    height: 2rem;
    @media (max-width: 50rem){
      height: 1.5rem;
    }
    @media (max-width: 32rem){
      height: 1.3rem;
    }
  }
`

const RecruitBar = styled.div`
  flex: 0 0 100%;
  display: flex;
  justify-content: space-between;
  background-color: #f2a7b3;
  padding: 1rem;
`
const RecruitBarItem = styled(Link)`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`
const RecruitBarItemIcon = styled.div`
  svg {
    height: 1.5rem;
    width: auto;
    display: block;
    @media (max-width: 30rem){
      font-size: 0.6rem;
    }
  }
`
const RecruitBarItemLabel = styled.div`
  font-size: 0.8rem;
  font-weight: 700;
  color: white;
  @media (max-width: 30rem){
    font-size: 0.65rem;
  }
`

type HeaderProps = {

}
export const Header: FunctionComponent<HeaderProps> = () => {
  const isMobile = useBreakpoint('40rem')
  const isInRecruitPage = /\/recruit(\/.*)?/.test(useLocation().pathname)
  return <Outer>
    <Inner>
      <Inner2>
        <LogoContainer to="/">
          {
            isInRecruitPage ?
            <SvgLogoWithRecruit /> :
            <SvgLogo />
          }
        </LogoContainer>
        {
          isInRecruitPage ? 
          <RecruitItem>
            <HomeButtonContainer to="/">
              <SvgHomeLinkButton />
            </HomeButtonContainer>
            <RecruitIconContainer>
              <RecruitIconItem href="https://www.youtube.com/channel/UCKdWbs154T5fYUmL4T1icgg"><SvgYoutubeIcon /></RecruitIconItem>
              <RecruitIconItem href="https://www.instagram.com/muronokisensei/"><SvgInstagramIcon /></RecruitIconItem>
              <RecruitIconItem href=""><SvgTiktokIcon /></RecruitIconItem> {/* FIXME */}
              {
                !isMobile && <>
                  <RecruitIconItem href="/recruit#mousikomi"><SvgRecHeaderMousikomi /></RecruitIconItem> {/* FIXME */}
                  <RecruitIconItem href="/recruit/setumei-entry"><SvgRecHeaderSetumei /></RecruitIconItem> {/* FIXME */}
                  <RecruitIconItem href="/recruit/contact"><SvgRecHeaderContact /></RecruitIconItem> {/* FIXME */}
                </>
              }
            </RecruitIconContainer>
          </RecruitItem> :
          isMobile ?
          <MobileHeaderMenu /> :
          <MenuContainer>
            <MenuItem to="/kitami">学校法人<br />北見学園</MenuItem>
            <MenuItem to="/muronoki">室の木幼稚園<br />(3-5歳)</MenuItem>
            <MenuItem to="/kids-ami">プリスクール室の木<br />(0-2歳)</MenuItem>
            <MenuItem to="/grape-seed">GrapeSEED<br />(小学生)</MenuItem>
            <MenuItem to="/kosodate">子育て支援<br />未就園児</MenuItem>
            <MenuItem to="/staff">職員紹介</MenuItem>
            <MenuItem to="/advantage">園の特徴</MenuItem>
          </MenuContainer>
        }
      </Inner2>
      {
        isInRecruitPage && isMobile && <RecruitBar>
          <RecruitBarItem to="/recruit#mousikomi">
            <RecruitBarItemIcon>
              <SvgRecMobileHeaderMousikomi />
            </RecruitBarItemIcon>
            <RecruitBarItemLabel>
              見学のお申し込み
            </RecruitBarItemLabel>
          </RecruitBarItem>
          <RecruitBarItem to="/recruit/setumei-entry">
            <RecruitBarItemIcon>
              <SvgRecMobileHeaderSetumei />
            </RecruitBarItemIcon>
            <RecruitBarItemLabel>
              オンライン説明会
            </RecruitBarItemLabel>
          </RecruitBarItem>
          <RecruitBarItem to="/recruit/contact">
            <RecruitBarItemIcon>
              <SvgRecMobileHeaderContact />
            </RecruitBarItemIcon>
            <RecruitBarItemLabel>
              お問い合わせ
            </RecruitBarItemLabel>
          </RecruitBarItem>
        </RecruitBar>
      }
    </Inner>
  </Outer>
}